import { membershipEventRepository } from '~/api/repository/membership-event';

export const MEMBERSHIP_EVENT_QUERY_KEY = {
  all: ['membership-event'] as const,

  // 플러스 멤버십 주간 이벤트 정보
  plusMembership: () => ({
    queryKey: [...MEMBERSHIP_EVENT_QUERY_KEY.all, 'plus-membership'] as const,
    queryFn: () => membershipEventRepository.getPlusMembershipEvent(),
  }),
};
